import styled from 'styled-components'
import CreationToolSupercutField from '../../../../../../types/super-cut-field'
import FontPreviewItem from '../../../../../form-fields/super-cut/font-preview-list'

const FontPreview = styled(FontPreviewItem)`
    grid-column: span 2;
`

type Props = {
    field: CreationToolSupercutField
}

const CreationCaptureInfoFontFilePreview = ({ field }: Props) => {
    return (
        <FontPreview
            {...{
                field,
            }}
        />
    )
}

export default CreationCaptureInfoFontFilePreview
